module.exports = __webpack_public_path__ + "img/regular_electrical_fault.274d5db3.svg";